<template>
  <div class="page">
    <div class="page-bd max">
      <div class="table-box pd-20">
        <pageTitle :title="$t('page_title.School_member_expire')"></pageTitle>
        <myTableFilter
          @submit="handleSubmit"
          :show="{school_name: true, renewal_time: true, expireStatus: true,statusText: statusText}"
        />
        <myTable ref="table" :columns="columns" requestUrl="school/expired-list" :showPage="true">
          <!-- <template v-slot:status="{ data }">
            <a @click="handleClick(data.row)">{{ $t("info") }}</a>
          </template>-->
        </myTable>
      </div>
    </div>
  </div>
</template>

<script>
import myTableFilter from "@/components/myTableFilter";
import myTable from "@/components/myTable";
import pageTitle from "@/components/pageTitle";
export default {
  name: "expire",
  components: {
    myTableFilter,
    myTable,
    pageTitle
  },
  data () {
    return {
      statusText: {},
      columns: [
        {
          title: this.$t("school_record.id"),
          key: "school_id",
          align: "center"
        },
        {
          title: this.$t("school_record.name"),
          key: "school_cname",
          align: "center"
        },
        {
          title: this.$t("contact_name"),
          key: "contact_name",
          align: "center"
        },
        {
          title: this.$t("contact_mobile"),
          key: "contact_mobile",
          align: "center"
        },
        {
          title: this.$t("school_record.email"),
          key: "school_email",
          align: "center"
        },
        {
          title: this.$t("school_record.renewal_time"),
          key: "renewal_time",
          align: "center"
        },
        {
          title: this.$t("payment"),
          key: "renewal_cname",
          align: "center",
          //   slot: "status"
        },
      ],

      search: { page: 1, limit: 10 },
      list: [],
      total: 0
    };
  },
  created () {
    this.getBeforeList();
  },
  mounted () {
    this.$base.setMenuOpens();
  },
  methods: {
    getBeforeList () {
      this.$base.showLoading;
      this.$request.sendPost(
        "school/before-list",
        {},
        (success, data, error) => {
          this.$base.hideLoading();
          if (!success) return this.$base.msgErr(error.errmsg);
          let arr = data.renewals
          this.statusText = arr
        }
      );
    },
    handleSubmit (params) {
      this.$refs.table.reSearch(params);
    },
    handleClick (item) {
      this.$base.linkTo("/school/record_detail", { id: item.school_id });
    }
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/school/expire/expire.vue